import { CloseRounded } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useToggle } from 'react-use';

interface AnalysisBannerProps {
  children: ReactNode;
}

export const AnalysisBanner = ({ children }: AnalysisBannerProps) => {
  const [isHidden, toggleIsHidden] = useToggle(false);

  if (isHidden) {
    return null;
  }

  return (
    <Paper elevation={6}>
      <Stack
        pl={2}
        pr={1}
        pt={0.25}
        pb={0.5}
        spacing={1}
        direction="row"
        alignItems="center"
      >
        <Typography variant="caption">{children}</Typography>
        <IconButton size="small" onClick={toggleIsHidden}>
          <CloseRounded fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  );
};
